module.exports = __webpack_public_path__ + "img/schemeList05Display02.08effe65.jpg";